import howToUserStep1 from "../../assets/images/howToUseStep1.png";
import howToUserStep2 from "../../assets/images/howToUseStep2.png";
import howToUserStep3 from "../../assets/images/howToUseStep3.png";
import styles from "./ProductField.module.css"

const HowToUse = () => {
  return (
    <div className={` ${styles.descriptionBlock} ${styles.howtoCont}`}>
      <div className={`h5-light ${styles.textCont}`}>
        <p>
          Choose the required format and download the assets.
        </p>

        <img src={howToUserStep1} alt="How To User Step 1" />

        <p>
          Each paid product includes one <b>free asset</b> — an OpenGate grid, shot at an “infinity” focus distance (for Zoom lenses — infinity focus with shorter focal length)
        </p>

        <img src={howToUserStep2} alt="How To User Step 2" />

        <p>
          <b>No matching format available?</b> Use the OpenGate grids included with the paid studio assets. How to adapt them to your required format — see the instructions
          <a  href="https://grids.matchmovemachine.com/tutorials/how-to-properly-crop-distortion-grids"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.blueLink}> here</a>.
        </p>

        <p>
          For free user-generated products, OpenGate grids may be missing. In that case, look for the same product from another user, or find grids shot on a larger format than the one you need and adapt them using the same instructions.
        </p>

        <p>
          After purchasing a product, download either an individual asset (the Download button next to the asset) or the full asset pack for that product (the “Download all” button).
        </p>

        <img src={howToUserStep3} alt="How To User Step 3" />
      </div>
    </div>
  );
};

export default HowToUse;
